<template>
  <a href="/" class="m-header__brand" :title="shopName">
    <picture class="a-image a-image--contain" :style="'--padding-ratio:' + props.height / props.width">
      <img v-if="(props.logoLink?.length ?? 0) > 0 " class="a-image__img" :src="props.logoLink" :alt="shopName + ' Logo'" loading="lazy">
      <img v-else class="a-image__img" src="../assets/img/fallback-logo.svg" :alt="shopName + ' Logo'" loading="lazy">
    </picture>
  </a>
</template>

<script setup lang="ts">
const props = defineProps({
  logoLink: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  shopName: {
    type: String,
    required: true,
    default: ''
  }
})
</script>
